import { render, staticRenderFns } from "./BranchCreate.vue?vue&type=template&id=56edc226&scoped=true"
import script from "./BranchCreate.vue?vue&type=script&lang=js"
export * from "./BranchCreate.vue?vue&type=script&lang=js"
import style0 from "./BranchCreate.vue?vue&type=style&index=0&id=56edc226&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56edc226",
  null
  
)

export default component.exports